module.exports = __webpack_public_path__ + "img/testimonials-icon-orange2.da2b50df.svg";